export enum ToolbarType {
  FULL = "FULL",
  BASIC = "BASIC"
}
